// Export all services
export { default as apiService } from './apiService';
export { default as walletService } from './walletService';
export { default as notificationService } from './notificationService';
export { default as sportsService } from './sportsService';
export { default as gamesService } from './gamesService';
export { default as clubService } from './clubService';
export { default as affiliateService } from './affiliateService';
export { default as swapService } from './swapService';
export { default as uiService } from './uiService';

// Default export for convenience
export default {
  apiService: require('./apiService').default,
  walletService: require('./walletService').default,
  notificationService: require('./notificationService').default,
  sportsService: require('./sportsService').default,
  gamesService: require('./gamesService').default,
  clubService: require('./clubService').default,
  affiliateService: require('./affiliateService').default,
  swapService: require('./swapService').default,
  uiService: require('./uiService').default,
}; 